<template>
  <div class="mini-launcher" :class="{ 'mini-launcher--compact': compact }">
    <div v-if="canUseOpenTag && !fallbackVisible" class="open-tag-wrap">
      <div ref="launchHost" class="open-tag-host"></div>
      <p class="launch-hint">点击按钮后，微信将打开小程序迁移页面</p>
      <button type="button" class="fallback-link" @click="showFallback">
        无法打开？查看小程序码
      </button>
    </div>

    <div v-else class="fallback-panel">
      <img
        class="mini-code"
        :src="qrCodeUrl"
        alt="新民晚报读者俱乐部小程序码"
      />
      <p class="fallback-title">长按识别小程序码</p>
      <p class="fallback-desc">也可在微信搜索“{{ miniProgramName }}”</p>
      <!-- <button type="button" class="copy-name" @click="copyName">
        复制小程序名称
      </button> -->
    </div>
  </div>
</template>

<script>
import { trackMigrationEvent } from "@/utils/migrationCampaign";

const DEFAULT_PATH =
  "subpackage/user/gzh-migration/index.html?from=h5_migration";

export default {
  name: "MiniProgramLauncher",
  props: {
    compact: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const originalId = process.env.VUE_APP_MINIPROGRAM_ORIGINAL_ID || "";
    const isWeChat = /MicroMessenger/i.test(navigator.userAgent || "");
    return {
      originalId,
      isWeChat,
      fallbackVisible: !(isWeChat && originalId),
      launchReady: false,
      qrCodeUrl: "qrcode_26.png",
      miniProgramName: "新民晚报读者俱乐部",
    };
  },
  computed: {
    canUseOpenTag() {
      return Boolean(this.isWeChat && this.originalId);
    },
  },
  mounted() {
    if (!this.canUseOpenTag) {
      trackMigrationEvent("qr_fallback_view", {
        reason: this.isWeChat ? "missing_original_id" : "outside_wechat",
      });
      return;
    }
    this.$nextTick(this.mountOpenTag);
    this.readyTimer = window.setTimeout(() => {
      if (!this.launchReady) this.activateFallback("open_tag_timeout");
    }, 3500);
  },
  beforeUnmount() {
    window.clearTimeout(this.readyTimer);
  },
  methods: {
    mountOpenTag() {
      const host = this.$refs.launchHost;
      if (!host) return;

      const launcher = document.createElement("wx-open-launch-weapp");
      launcher.setAttribute("username", this.originalId);
      launcher.setAttribute("path", DEFAULT_PATH);
      launcher.innerHTML =
        `
        <script type="text/wxtag-template">
          <style>
            .launch-button { width: 100%; height: 58px; border: 0; border-radius: 29px; color: #fff; background: linear-gradient(100deg, #b71f18, #e44739); box-shadow: 0 8px 20px rgba(183, 31, 24, 0.32); font-size: 19px; font-weight: 700; }
          </style>
          <button class="launch-button">立即迁移积分</button>
      ` +
        "</" +
        "script>";
      launcher.addEventListener("ready", () => {
        this.launchReady = true;
        window.clearTimeout(this.readyTimer);
      });
      launcher.addEventListener("launch", () => {
        trackMigrationEvent("direct_launch_success", { target: DEFAULT_PATH });
      });
      launcher.addEventListener("error", (event) => {
        this.activateFallback(
          event && event.detail ? "open_tag_error" : "open_tag_unknown_error"
        );
      });
      host.appendChild(launcher);
    },
    activateFallback(reason) {
      this.fallbackVisible = true;
      trackMigrationEvent("direct_launch_fail", { reason });
    },
    showFallback() {
      this.activateFallback("user_requested_qr");
    },
    // async copyName() {
    //   try {
    //     await navigator.clipboard.writeText(this.miniProgramName);
    //     this.$message.success("小程序名称已复制");
    //   } catch (error) {
    //     this.$message.info(`请在微信搜索“${this.miniProgramName}”`);
    //   }
    //   trackMigrationEvent("mini_program_name_copy");
    // },
  },
};
</script>

<style lang="less" scoped>
.mini-launcher {
  width: 100%;
}

.open-tag-host,
.open-tag-host :deep(wx-open-launch-weapp) {
  display: block;
  width: 100%;
  min-height: 58px;
}

.launch-hint,
.fallback-desc {
  margin: 10px 0 0;
  color: #777;
  font-size: 20px;
  line-height: 1.6;
  text-align: center;
}

.fallback-link,
.copy-name {
  display: block;
  margin: 8px auto 0;
  border: 0;
  color: #b9231a;
  background: transparent;
  font-size: 20px;
}

.fallback-panel {
  padding: 18px;
  border-radius: 18px;
  background: #fff8f4;
  text-align: center;
}

.mini-code {
  display: block;
  width: 68vw;
  max-width: 280px;
  margin: 0 auto;
  border-radius: 12px;
  background: #fff;
}

.fallback-title {
  margin: 14px 0 0;
  color: #2d2522;
  font-size: 20px;
  font-weight: 700;
}

.copy-name {
  min-height: 42px;
  padding: 0 18px;
  border: 1px solid #e4b6aa;
  border-radius: 21px;
  background: #fff;
}

.mini-launcher--compact .mini-code {
  width: 58vw;
  max-width: 220px;
}
</style>
